import { useUpdatePartnerAgencyMutation } from '@anytag/graphql';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useQueryHelper } from '@anytag/shared-hooks';
import { PartnerForm, PartnerFormValues } from '@anytag/shared-organisms';
import { FormAction, ToggleOption } from '@anytag/shared-types';
import { usePartnerDetailsContext } from './partner-details-context';

export const EditPartner = () => {
  const { partner } = usePartnerDetailsContext();
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { callUpdatePartnerAgency } = useUpdatePartnerAgencyMutation();

  const handleSubmit: FormAction<PartnerFormValues>['onSubmit'] = async ({
    logo,
    agencyIds,
    countryId,
    netsuiteId,
    companyUrl,
    phoneNumber,
    advertiserIds,
    partnerAgencyName,
    privateInfluencerIds,
    influencerCostPermission
  }) => {
    try {
      await callUpdatePartnerAgency({
        variables: {
          input: {
            logo,
            countryId,
            id: partner.id,
            partnerAgencyName,
            companyUrl: companyUrl || null,
            netsuiteId: netsuiteId || null,
            phoneNumber: phoneNumber || null,
            agencyIds: agencyIds.map(Number),
            advertiserIds: advertiserIds.map(Number),
            privateInfluencersIds: privateInfluencerIds.map(Number),
            influencerCostPermission: influencerCostPermission === ToggleOption.TRUE ? true : false
          }
        }
      });
      enqueueSnackbar(t('succeededInUpdating', { name: partnerAgencyName }), { variant: 'success' });
      navigate({ to: '/partner' });
    } catch (error) {
      enqueueSnackbar(t('failedToUpdate', { name: partnerAgencyName }), { variant: 'error' });
      enqueueSnackbar(t(error.message || UNEXPECTED_ERROR), { variant: 'error' });
    }
  };

  return (
    <PartnerForm
      defaultValues={{
        id: partner.id,
        logo: partner.logo || '',
        countryId: partner.country?.id,
        partnerAgencyName: partner.name,
        companyUrl: partner.companyUrl || '',
        netsuiteId: partner.netsuiteId || '',
        phoneNumber: partner.phoneNumber || '',
        agencyIds: partner.agencyIds.map(String),
        advertiserIds: partner.advertiserIds.map(String),
        influencerCostPermission: partner.influencerCostPermission ? ToggleOption.TRUE : ToggleOption.FALSE,
        privateInfluencerIds: partner.privateInfluencers.map((infl) => infl.id.toString()) || []
      }}
      onSubmit={handleSubmit}
    />
  );
};
